import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import ResponsiveContainer from './ResponsiveContainer';

function SuccessScreenPage({ t, resetRegistrationData, onLogout }) {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      // Clear all registration data before navigating back to dashboard
      onLogout();
      resetRegistrationData();
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, resetRegistrationData]);

  return (
    <ResponsiveContainer>
      <h2>{t('success')}</h2>
      <p>{t('successMessage')}</p>
    </ResponsiveContainer>
  );
}

export default SuccessScreenPage;
